import __vue_normalize__ from '../../../../common/temp/node_modules/.pnpm/registry.npmjs.org/vue-runtime-helpers/1.1.2/node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './TcModal.vue_rollup-plugin-vue=script.js';
import './TcModal.vue_rollup-plugin-vue=styles.0.css.js';

/* script */
var __vue_script__ = script;
/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"modal-wrapper",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.hideModal($event)}}},[_c('div',{staticClass:"tc-modal tc-layer-modal",attrs:{"aria-modal":"true","role":"dialog","aria-labelledby":"dialog-title"}},[(_vm.closeButton)?_c('button',{ref:"closeButton",staticClass:"close-button",staticStyle:{"border":"none","background":"none"},attrs:{"tabindex":"0"},on:{"click":_vm.hideModal,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }if(!$event.shiftKey){ return null; }$event.preventDefault();return _vm.focusOverlay($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.focusCloseButton($event)}]}},[_c('cross-new',{class:_vm.iconClass,attrs:{"viewBox":"0 0 18 18"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-content",class:_vm.setPadding('modal-content')},[_c('div',{staticClass:"scrollable-content",class:_vm.setPadding('scrollable-content')},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"tc-modal__footer tc-shadow--shallow"},[_vm._t("footer")],2)])]),_vm._v(" "),_c('div',{ref:"overlay",staticClass:"tc-overlay tc-overlay-dark--strong",attrs:{"tabindex":"0"},on:{"click":_vm.hideModal,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.preventDefault();return _vm.focusCloseButton($event)}}})]):_vm._e()};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
